import logo from "./logo.svg";
import "./App.css";
import { MainList } from "./components/Main";

function App() {
  return (
    <div className="App">
      <MainList />
    </div>
  );
}

export default App;
